<div class="main row">
  <ds-confirmation [confirmationData]="confirmationData">
    <!-- Content if EZ button not enabled -->
    <div class="row margin-vertical-20">
      <div class="column md-four lg-three six">
        <b>What's included:</b><br />
        <ul class="bullet -superCondensed pad-bottom-0">
          <li>Insurance cards</li>
          <li>Coverage documents</li>
        </ul>
      </div>
      <div class="column md-four lg-three six">
        <b>What's NOT included:</b><br />
        <ul class="bullet -superCondensed pad-bottom-0">
          <li>Billing statements</li>
        </ul>
      </div>
    </div>
    <!-- EZ Button content -->
    <div class="margin-top-30">
      <p>
        We’ll send a notification to
        <b><span [innerHTML]="user?.emailAddress ? user?.emailAddress : 'your email'"></span></b>
        whenever you have a new document. This includes:
      </p>
      <div class="row pad-top-10">
        @for (acc of updatedPreferenceBillAccounts; track acc) {
          <div class="column twelve list confirmation-status">
            <span class="icon icon-complete-circle"></span>
            <span
              >Bills for
              {{
                acc.billingPreferences?.accountNickName
                  ? acc.billingPreferences?.accountNickName
                  : acc.billAccountNumber
              }}</span
            >
          </div>
        }
        <div class="column twelve list confirmation-status">
          <span class="icon icon-complete-circle"></span>
          <div>
            <div>Policy documents</div>
            <span class="caption">Insurance cards and coverage documents</span>
          </div>
        </div>
      </div>
      <p class="pad-vertical-20">
        Need to change your email address? You can update your contact info under
        <a href="javascript:void(0)" dsRouterLink="/profile">Profile</a>.
      </p>
    </div>

    <ds-confirmation-link-area>
      <a class="font-weight-semibold" data-cy="goPaperlessBackButton" (click)="backToOverview()"
        >Back To Overview</a
      >
    </ds-confirmation-link-area>
  </ds-confirmation>
</div>
